import { Abbr } from "@site/src/components";

export default function ThirdPersonSingularMasculineNeuter() {
  return (
    <table
      className="table_sticky"
    >
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th />
          <th><Abbr>nom.</Abbr></th>
          <th><Abbr>acc.</Abbr></th>
          <th><Abbr>gen.</Abbr></th>
          <th><Abbr>dat.</Abbr></th>
          <th><Abbr>ins.</Abbr></th>
          <th><Abbr>loc.</Abbr></th>
        </tr>
        <tr>
          <th>OCS</th>
          <td>
            jь; je
            <br />
            [onъ; ono]
          </td>
          <td>jь; je</td>
          <td>jego</td>
          <td>jemu</td>
          <td>imъ</td>
          <td>jemъ</td>
        </tr>
        <tr>
          <th>Russian</th>
          <td> on; onó </td>
          <td>jegó </td>
          <td>jegó </td>
          <td>jemú </td>
          <td>im</td>
          <td>nëm</td>
        </tr>
        <tr>
          <th>Belarussian</th>
          <td> ën; janó </td>
          <td>jahó </td>
          <td>jahó </td>
          <td>jamú </td>
          <td>im</td>
          <td>im</td>
        </tr>
        <tr>
          <th>Ukrainian</th>
          <td> vin; vonó</td>
          <td>johó </td>
          <td>johó </td>
          <td>jomú </td>
          <td>nym </td>
          <td>n'ómu/nim</td>
        </tr>
        <tr>
          <th>Lemko-Rusyn</th>
          <td> vin; ono</td>
          <td>joho/ho </td>
          <td>joho/ho </td>
          <td>jomu/mu </td>
          <td>nym </td>
          <td>nym</td>
        </tr>
        <tr>
          <th>Polish</th>
          <td> on; ono </td>
          <td>jego/go </td>
          <td>jego/go </td>
          <td>jemu/mu </td>
          <td>nim </td>
          <td>nim</td>
        </tr>
        <tr>
          <th>Cashubian</th>
          <td> on; ono/no </td>
          <td>jego/jen/go; je</td>
          <td>jego </td>
          <td>jemu/mu </td>
          <td>nim </td>
          <td>nim</td>
        </tr>
        <tr>
          <th>Lower Sorbian</th>
          <td> won; wono</td>
          <td>jogo/jen; jo </td>
          <td>jogo </td>
          <td>jomu </td>
          <td>nim </td>
          <td>njom</td>
        </tr>
        <tr>
          <th>Upper Sorbian</th>
          <td> wón; wono/wone</td>
          <td>jeho/jón; jo/je </td>
          <td>jeho </td>
          <td>jemu </td>
          <td>nim </td>
          <td>nim</td>
        </tr>
        <tr>
          <th>Czech</th>
          <td> on; ono </td>
          <td>jeho/jej/ho; je/jej/ho</td>
          <td>jeho/jej/ho</td>
          <td>jemu/mu </td>
          <td>jím </td>
          <td>něm</td>
        </tr>
        <tr>
          <th>Slovak</th>
          <td> on; ono </td>
          <td>jeho/ho; ho </td>
          <td>jeho/ho </td>
          <td>jemu/mu </td>
          <td>ním </td>
          <td>ňom</td>
        </tr>
        <tr>
          <th>Slovene</th>
          <td> on; ono </td>
          <td>njega </td>
          <td>njega </td>
          <td>njemu </td>
          <td>njim</td>
          <td>njem</td>
        </tr>
        <tr>
          <th>Serbian/Croatian</th>
          <td> ôn; òno </td>
          <td>njèga/ga </td>
          <td>njèga/ga </td>
          <td>njèmu/mu</td>
          <td>njîm</td>
          <td>njèmu</td>
        </tr>
        <tr>
          <th>Macedonian</th>
          <td> toj; toa</td>
          <td>nego/go </td>
          <td>— </td>
          <td>nemu/mu </td>
          <td>— </td>
          <td>—</td>
        </tr>
        <tr>
          <th>Bulgarian</th>
          <td> toj; to</td>
          <td>négo/go </td>
          <td>— </td>
          <td>mu/nému </td>
          <td>— </td>
          <td>—</td>
        </tr>
        <tr>
          <th>Interslavic</th>
          <td>
            <b>on; ono</b>
          </td>
          <td>
            <b>(n)jego</b>
          </td>
          <td>
            <b>(n)jego</b>
          </td>
          <td>
            <b>(n)jemu</b>
          </td>
          <td>
            <b>(n)jim</b>
          </td>
          <td>
            <b>(n)jim</b>
          </td>
        </tr>
      </tbody>
    </table>
  )
}
